import Vue from 'vue'
// import Vant from 'vant';
import App from './App.vue'
import router from './router/index';
import DateUtil from './utils/date-util'
import less from 'less'
import { saveTokenFromUrl } from './utils/auth'
import { saveApiKeyFromUrl } from './utils/api-signature'
// import 'vant/lib/index.css';
Vue.use(less)
// Vue.use(Vant);

// 進入應用時，路由(url)上帶了 token 才存到 sessionStorage（key = jb-authorization）；沒帶則不做任何處理
saveTokenFromUrl()

// 進入應用時，路由(url)上帶了 apiKey 才存到 sessionStorage（key = jb-api-signature-key）；沒帶則不做任何處理
saveApiKeyFromUrl()

Vue.config.productionTip = false
Vue.prototype.$util={
  ...DateUtil
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
